import { useTranslation } from "react-i18next";
import {LOGIN_PATH, SESSION_CHECK_INTERVAL} from "../../utils/constants";
import { YuJaGlobalState} from "../../utils/LoadingContext";
import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {useSession} from "../../hooks/useSession";
import {AuthenticationApiCalls} from "../../apis/AuthenticationApiCalls";
import useQuery from "../../utils/queryparam";
import {notifyError, updateCSMMainBackground, updateMainBackground} from "../../utils/helpers";
import styles from "./CSMLayout.module.css";
import YuJaTokenExpiredAlert from "../../components/modals/YuJaTokenExpiredAlert";
import CSMNavBar from "./CSMNavBar";
import {useCSMAccessCheck} from "../../hooks/useCSMAccessCheck";

export default function CSMLayout({children, isAdminExclusive = false}) {
    const { t } = useTranslation();
    // const [rightSidebarContent, setRightSidebarContent] = useState();
    // useHostname(window.location.hostname); // do not remove this line - needed to set the host resource which has institutionId
    const history = useHistory();
    const location = useLocation();
    const [setSession, getSession] = useLocalStorageNew("session", {});
    const [visibility, setVisibility] = useState(true);
    const intervalIdRef = useRef(0);
    const {checkExpired, checkWillExpired} = useSession();
    const {reLogin, loginSAML, } = AuthenticationApiCalls();
    let {isCSMAdmin} = useCSMAccessCheck();
    let query = useQuery();
    // const [isLMS, setIsLMS] = useState(false);
    const [pageIdentifier, setPageIdentifier] = useState("");

    const session = getSession();

    const [tokenValidateRes, setTokenValidateRes] = useState(false);
    const [roleValidateRes, setRoleValidateRes] = useState(false);
    const [sessionExpiredRes, setSessionExpiredRes] = useState(false);

    const {setIsTokenExpiredModalShowUp,} = useContext(YuJaGlobalState);


    const clearSessionCheckInterval = () => {
        if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = 0;
        }
    };



    useEffect(() => {
        if (location.state && location.state.msg) {
            notifyError(location.state.msg);
            const newState = {...location.state};
            newState.msg = null;
            location.state = newState;
        }



    }, [location.state]);

    useEffect(() => {
        const {authorization = '', userName = '', } = session;
        const tokenValidateRes = !!authorization && !!userName;
        const roleValidateRes = isAdminExclusive ? isCSMAdmin() : true;
        const sessionExpiredRes = checkExpired();
        if (!query.get("secret") && !tokenValidateRes) {
            setIsTokenExpiredModalShowUp(false);
            history.push(LOGIN_PATH, {from: location.pathname});
            setSession({});
            return;
        }

        if (tokenValidateRes && !roleValidateRes) {
            setIsTokenExpiredModalShowUp(false);
            notifyError(t("institution.noPagePermission"));
            history.push(LOGIN_PATH);
            return;
        }

        if (!query.get("secret") && sessionExpiredRes) {
            setIsTokenExpiredModalShowUp(false);
            history.push(LOGIN_PATH, {from: location.pathname});
            setSession({});
            return;
        }
        setTokenValidateRes(tokenValidateRes);
        setRoleValidateRes(roleValidateRes);
        setSessionExpiredRes(sessionExpiredRes);
        setIsTokenExpiredModalShowUp(false);

        if (query.get("secret") && query.get("intType")) {
            if (query.get("intType").toLowerCase() === "adfs") {
                loginSAML(query.get("secret"), query.get("intType"));
            }
        }
    }, []);

    useEffect(() => {
        if (document.visibilityState === "hidden") {
            clearSessionCheckInterval();
            return;
        }

        if (document.visibilityState !== "visible") {
            return;
        }


        //session is empty
        if ((!session || !Object.entries(session).length)) {
            setIsTokenExpiredModalShowUp(false);
            history.push(LOGIN_PATH);
            setSession({});
            return;
        }

        //token is expired
        if (checkExpired()) {
            clearSessionCheckInterval();
            setIsTokenExpiredModalShowUp(true);
            return;
        }

        //token will expire soon
        intervalIdRef.current = setInterval(() => {
            console.log("check session if it will be expired...")
            if (checkWillExpired()) {
                reLogin();
            }
        }, SESSION_CHECK_INTERVAL);

        return () => {
            clearSessionCheckInterval();
        };
    }, [visibility]);


    useEffect(() => {
        const observer = new MutationObserver(() => {
            let found = updateCSMMainBackground();
            if (found) {
                observer.disconnect();
            }
        });
        observer.observe(document, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, [children]);



    const handleVisibilityChange = useCallback(() => {
        if (document.visibilityState === "hidden") {
            setVisibility(false);
        } else if (document.visibilityState === "visible") {
            setVisibility(true);
        }
    }, []);


    useEffect(() => {
        window.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            window.removeEventListener("visibilitychange", handleVisibilityChange);
        }
    }, [handleVisibilityChange]);


    return (tokenValidateRes && roleValidateRes && !sessionExpiredRes &&
        <>
            <CSMNavBar pageIdentifier={pageIdentifier}/>

            <main className={styles.mainSectionStyle}>
                {React.cloneElement(children, {
                    setPageIdentifier: setPageIdentifier
                })}
            </main>

            <YuJaTokenExpiredAlert/>
        </>
    );
}
